import React, { Component } from 'react'
import {Grid,Cell,List,ListItem,ListItemContent} from 'react-mdl';
export default class Contact extends Component {
  render() {
    return (
      <div className="contact-body">
      <Grid className="contact-grid">

      <Cell col={6}>
      <h2>Shamaz Shaikh</h2>
      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS4uAfoapDbR_ycxF4hltMedCYIqj9bcOZB-ZuD8Sf89rdrGtTv"
      alt="avatar" style={{height:'250px'}}/>
      <p style={{width:'75%',margin:'auto',paddingTop:'1em'}}>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil ex quas minima nobis sapiente beatae asperiores recusandae dolor, dicta amet facere minus quaerat voluptatum voluptas veniam officia ipsam temporibus dolores!

      </p>
      </Cell>
      <Cell col={6}>
      <h2>Contact Me</h2>
      <hr/>
      <div className="contact-list">
      <List>
  <ListItem>
    <ListItemContent className="list-style">
    <i className="fa fa-phone-square" aria-hidden="true"></i>
    03087175332</ListItemContent>
  </ListItem>
  <ListItem>
    <ListItemContent className="list-style">
    <i className="fa fa-envelope" aria-hidden="true"></i>
    shamazsaeed332@gmail.com</ListItemContent>
  </ListItem>
</List>

      </div>
     
      </Cell>
        </Grid> 
       
      </div>
    )
  }
}
